import type { TFunction } from 'i18next';

/**
 * The OAuth callbacks send the browser back with `reason=<code>`, a fixed
 * code and never a free text (AUDIT-INT-10, AUDIT-INT-15: a crafted link
 * could otherwise put a sentence of its choosing on the settings screen).
 * This turns the code into the sentence the screen shows; an unknown code
 * gets the generic one, never the raw value.
 */
export function oauthReasonMessage(t: TFunction, reason: string | null | undefined): string {
  switch (reason) {
    case 'missing_params': return t('settings:oauthReasons.missingParams');
    case 'state_invalid': return t('settings:oauthReasons.stateInvalid');
    case 'session_mismatch': return t('settings:oauthReasons.sessionMismatch');
    case 'exchange_failed': return t('settings:oauthReasons.exchangeFailed');
    case 'no_refresh_token': return t('settings:oauthReasons.noRefreshToken');
    case 'no_email': return t('settings:oauthReasons.noEmail');
    case 'user_not_found': return t('settings:oauthReasons.userNotFound');
    case 'provider_denied': return t('settings:oauthReasons.providerDenied');
    case 'not_configured': return t('settings:oauthReasons.notConfigured');
    case 'customer_not_found': return t('settings:oauthReasons.customerNotFound');
    default: return t('settings:oauthReasons.unknown');
  }
}
